import { omit } from 'lodash';

import { LogicDataContext } from './build-step-logic-data-context';

type mergeLogicDataContextParam = {
  stepLogicDataContext: LogicDataContext;
  blocksLogicDataContext: LogicDataContext;
  keepStepContextForKey: string;
};

export function mergeLogicDataContext({
  stepLogicDataContext,
  blocksLogicDataContext,
  keepStepContextForKey,
}: mergeLogicDataContextParam): LogicDataContext {
  const mergeLogicDataContext: LogicDataContext = {
    affiliated_company: {
      ...stepLogicDataContext.affiliated_company,
      ...omit(blocksLogicDataContext.affiliated_company, keepStepContextForKey),
    },
    case: {
      ...stepLogicDataContext.case,
      ...omit(blocksLogicDataContext.case, keepStepContextForKey),
    },
    main_company: {
      ...stepLogicDataContext.main_company,
      ...omit(blocksLogicDataContext.main_company, keepStepContextForKey),
    },
    individual: {
      ...stepLogicDataContext.individual,
      ...omit(blocksLogicDataContext.individual, keepStepContextForKey),
    },
  };

  return mergeLogicDataContext;
}
